import { LabeledInput } from "../../../Components/ConfigurationTab/LabeledInput";
import { UnitAdornment } from "../../../Components/ConfigurationTab/UnitAdornment";
import { quantity_regex } from "./priceField";
import { SETTINGS_LABEL_PLACEMENT } from "./constants";
import { useFormikContext } from "formik";

export const AdvancedField = <T extends string>(props: {
  label: string;
  name: T;
  type?: string;
  disabled?: boolean;
  placeholder?: string;
  /** Defaults to the settings row's caption on top. */
  labelPlacement?: "start" | "top";
  /** See `LabeledInput`; for lining up a column of side-labelled fields. */
  labelWidth?: number | string;
  /** Shown inside the input's right edge, like the price fields' ¥/kWh. */
  unit?: string;
}) => {
  const labelPlacement = props.labelPlacement ?? SETTINGS_LABEL_PLACEMENT;
  const { values, setFieldValue } =
    useFormikContext<{ [K in T]: string | undefined | number }>();
  const onChangeFn = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    setFieldValue(props.name, value);
    const newValue = value.replace(",", ".");
    if (props.type === "number" && newValue !== value) {
      setFieldValue(props.name, newValue);
    } else {
      setFieldValue(props.name, value);
    }
  };

  if (props.type === "number") {
    return (
      <LabeledInput
        value={values[props.name]}
        onChange={onChangeFn}
        name={props.name}
        placeholder={props.placeholder}
        type="number"
        label={props.label}
        labelPlacement={labelPlacement}
        labelWidth={props.labelWidth}
        disabled={props.disabled}
        endAdornment={
          props.unit === undefined ? undefined : (
            <UnitAdornment unit={props.unit} />
          )
        }
        inputProps={{
          pattern: quantity_regex,
        }}
      />
    );
  }
  return (
    <LabeledInput
      value={values[props.name]}
      onChange={onChangeFn}
      name={props.name}
      placeholder={props.placeholder}
      type="text"
      label={props.label}
      labelPlacement={labelPlacement}
      labelWidth={props.labelWidth}
      disabled={props.disabled}
      endAdornment={
        props.unit === undefined ? undefined : (
          <UnitAdornment unit={props.unit} />
        )
      }
    />
  );
};
